var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "h1",
    { staticClass: "shop-headline" },
    [
      _vm.icon === "cart" ? [_vm._m(0)] : _vm._e(),
      _vm._v(" "),
      _vm.icon === "star" ? [_vm._m(1)] : _vm._e(),
      _vm._v(" "),
      _c("span", { domProps: { innerHTML: _vm._s(_vm.headline) } }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon-item icon-item--ghost" }, [
      _c("span", { staticClass: "icon icon--shop" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon-item icon-item--ghost" }, [
      _c("span", { staticClass: "icon icon--wishlist-empty" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }